import React, { useEffect, useCallback, useState, useContext } from 'react'
import { API } from 'api/API';
import { Table, Card, Button, Alert, Spinner } from 'react-bootstrap';
import { ONECLICKPAYMENTS_URL, BUSINESS_DONATION_CAUSES } from 'config/config';
import { extractError } from 'api/ErrorUtil';
import _ from "lodash";
import { SecurityContext } from '../../security/SecurityContext';
import { TenantContext } from '../../tenant/TenantContext';
import { formatDate } from 'util/Date';
import { formatCurrency } from 'util/Currency';
import { evenRound } from 'util/NumberUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faDollar, faEdit } from '@fortawesome/free-solid-svg-icons'
import { useNavigate } from 'react-router-dom';
import { NewButton } from 'uiwidgets/NewButton';

const OneClickPaymentListPage = () => {
    const [formData, setFormData] = useState({ errors: {} });
    const secCtx = useContext(SecurityContext);
    const { businessConfig } = useContext(TenantContext);
    const navigate = useNavigate();

    const getAccountById = (accountId) => {
        let filteredAccounts = formData.accounts.filter(account => account.id === accountId);
        return filteredAccounts[0];
    }

    const getDonationCauseById = (causeId) => {
        let donationCauses = formData.donationCauses.filter(dc => dc.id == causeId);
        return donationCauses[0];
    }

    const getAccountTypeByAccountId = (accountId) => {
        let filteredAccounts = formData.accounts.filter(account => account.id === accountId);
        let filteredAccountTypes = formData.accountTypes.filter(accType => filteredAccounts[0].accountTypeId === accType.id);
        return filteredAccountTypes[0];
    }
    const fetchInitialData = useCallback(async () => {
        try {
            let oneClickPmtsSpecResp = await API.get(ONECLICKPAYMENTS_URL);
            let donationCauseResp = await API.get(BUSINESS_DONATION_CAUSES);
            setFormData({
                ...formData,
                oneClickPmtSpecs: oneClickPmtsSpecResp.data,
                accounts: secCtx.accounts,
                accountTypes: businessConfig.accountTypes,
                donationCauses: donationCauseResp.data,
            });

        } catch (error) {
            let exError = extractError(error);
            if (exError.httpStatus === 404) {
                setFormData({
                    ...formData,
                    oneClickPmtSpecs: [],
                    infoMessage: "No One-Click Payments were found"
                });

            } else {
                setFormData({
                    ...formData,
                    errors: exError
                });
            }
        }
    });

    useEffect(() => {
        fetchInitialData();
    }, []);

    const deleteOneClickPmt = async (event, oneClickPmtSpecId) => {
        try {
            await API.delete(ONECLICKPAYMENTS_URL + "/" + oneClickPmtSpecId);
            let oneClickPmtSpecResp = await API.get(ONECLICKPAYMENTS_URL);
            setFormData({
                ...formData,
                oneClickPmtSpecs: oneClickPmtSpecResp.data,
                infoMessage: "One Click Payment was successfully deleted"
            })
        } catch (error) {
            let exError = extractError(error);
            if (exError.httpStatus === 404) {
                setFormData({
                    ...formData,
                    oneClickPmtSpecs: [],
                    infoMessage: "No One-Click Payments were found"
                });

            } else {
                setFormData({
                    ...formData,
                    errors: exError
                });
            }
        }

    }

    const payOneClickPmt = async (event, oneClickPmtSpecId) => {
        try {
            //if (!window.confirm("Are you sure you want to make a one time payment")){
            //    return false;
           //}
            setFormData({
                ...formData,
                processing: oneClickPmtSpecId,
                infoMessage: "",
                errors: {}

            });
            let oneClickPmtSpecResp = await API.post(ONECLICKPAYMENTS_URL + "/" + oneClickPmtSpecId + "/actions/pay");
            //fetchInitialData();
            setFormData({
                ...formData,
                infoMessage: "One Click payment was successful",
                processing: null
            })
        } catch (error) {
            let exError = extractError(error);
            setFormData({
                ...formData,
                errors: exError,
                processing: null
            });
        }
    }
    const editOneClickPmt = async (event, oneClickPmtSpec) => {
        navigate("/edit-oneclick-payments/"+oneClickPmtSpec.id,{ state: { oneClickPmtSpec: oneClickPmtSpec } });
        return;
    }
    return (
        <>
            {!_.isEmpty(formData.errors) && formData.errors.httpStatus === 404 && <Alert key="info" variant="info">No One Click Payments were found!</Alert>}
            {!_.isEmpty(formData.errors) && formData.errors.httpStatus !== 404 && <Alert key="error" variant="danger">{formData.errors.message}</Alert>}
            {!_.isEmpty(formData.infoMessage) && <Alert key="info1" variant="info">{formData.infoMessage}</Alert>}

            <Card className="strpied-tabled-with-hover">
                <Card.Header>
                    {<Card.Title><h6>One Click Payments</h6></Card.Title>}
                    <NewButton label="Add New One Click Payment" onClick={(event) => { navigate("/add-oneclick-payments") }} />
                </Card.Header>
                <Card.Body className="table-full-width table-responsive px-0">
                    <Table>
                        <thead>
                            <tr>
                                <th className="border-0">Description</th>
                                <th className="border-0">Account Type</th>
                                <th className="border-0">Account Id</th>
                                <th className="border-0">Total Payment Amount</th>
                                <th className="border-0">Card</th>
                                <th className="border-0">Exp Date</th>
                                <th className="border-0">Detail</th>
                                <th className="border-0">Edit</th>
                                <th className="border-0">Delete</th>
                                <th className="border-0">Pay</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!_.isEmpty(formData.oneClickPmtSpecs) && formData.oneClickPmtSpecs.map((oneClickPmtSpec, idx) => (
                                <tr key={idx}>
                                    <td>{oneClickPmtSpec.description}</td>
                                    <td>{getAccountTypeByAccountId(oneClickPmtSpec.accountId).accountTypeDisplayName}</td>
                                    <td>{getAccountById(oneClickPmtSpec.accountId).number}</td>
                                    <td>{formatCurrency(evenRound(parseFloat(oneClickPmtSpec.paymentAmount)) / 100, businessConfig.locale, businessConfig.currency)}</td>
                                    <td>{oneClickPmtSpec.maskedCardNumber}</td>
                                    <td>{oneClickPmtSpec.expDate}</td>
                                    <td>{oneClickPmtSpec.oneClickPaymentSpecDetail.map((ocpsd, idx2) => (
                                        <div key={idx2}>
                                            {getDonationCauseById(ocpsd.causeId).donationCauseDescription + ": " + formatCurrency(evenRound(parseFloat(ocpsd.causeAmount)) / 100, businessConfig.locale, businessConfig.currency)} <br />
                                        </div>
                                    ))}</td>
                                    <td>
                                        <Button variant="dark" className="border-0 text-dark" onClick={evt => editOneClickPmt(evt, oneClickPmtSpec)}>
                                                    <FontAwesomeIcon icon={faEdit} title='Edit OneClick Payment'/>
                                                </Button>

                                        </td>
                                    <td><Button variant="dark" className="border-0 text-dark" onClick={evt => deleteOneClickPmt(evt, oneClickPmtSpec.id)}>
                                        <FontAwesomeIcon icon={faTrash} />
                                    </Button></td>
                                    <td>
                                    {formData.processing === oneClickPmtSpec.id ?  (
                                        <Spinner
                                        style={{ marginBottom: 27 }}
                                        animation="border"
                                        variant="success"
                                        /> ) :(
                                        <Button variant="dark" className="border-0 text-dark" onClick={evt => payOneClickPmt(evt, oneClickPmtSpec.id)}>
                                            <FontAwesomeIcon icon={faDollar} />
                                        </Button>)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

        </>)
}

export default OneClickPaymentListPage